import { alpha } from '@mui/material/styles';

const withAlphas = (color) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral = {
  50: '#F8F9FA',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927',
};

export const tertiary = withAlphas({
  lightest: '#F8F9FA',
  light: '#D2D6DB',
  main: '#6C737F',
  dark: '#2F3746',
  darkest: '#1C2536',
  contrastText: '#FFFFFF',
});

export const primary = withAlphas({
  lightest: '#F5F8FF',
  light: '#EBEFFF',
  main: '#46C1C5',
  dark: '#03242F',
  darkest: '#03242F',
  contrastText: '#FFFFFF',
});

export const success = withAlphas({
  lightest: '#F0FDF9',
  light: '#3FC79A',
  main: '#10B981',
  dark: '#0B815A',
  darkest: '#134E48',
  contrastText: '#FFFFFF',
});

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#CFF9FE',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF',
});

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF',
});

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#FEE4E2',
  main: '#F04438',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF',
  light_red: '#FFB2B2',
  red: '#FF0000',
});

export const weesu = {
  dark_blue: '#00242f',
  light_blue: '#31b7bc',
  light_green: '#a2c62c',
  dark_white: '#fffcfc',
  favorite: '#FFC107',
  green: '#00FF00',
};

export const communicate = {
  default: '#2B3A48',
  comment: '#757575',
  info: '#547891',
  warning: '#ff9800',
  critical: '#f44336',
  linkText: '#fff',
};

export const status = {
  synchronized: '#65b843',
  pending: '#f7f709',
  canceled: '#ff0000',
  newer: '#0086af',
  automatic: '#0086af',
  rejected: '#999999',
};
